import { Routes, RouterModule } from '@angular/router';
import { ListArchivosComponent } from './list-archivos.component';

export const routes: Routes = [
  {
    path: '',
    component: ListArchivosComponent,
  },
];

export const routing = RouterModule.forChild(routes);
